/* Lumora plus: announcement bar rotation */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBar(bar) {
    if (bar.__luAnn) return;
    bar.__luAnn = true;
    if (bar.getAttribute('data-anim') === 'marquee') return;
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.lu-ann__msg'));
    if (msgs.length < 2) return;
    var secs = parseFloat(bar.getAttribute('data-interval')) || 4;
    var cur = 0, paused = false, timer = null;

    function show(n) {
      var a = msgs[cur], b = msgs[n];
      if (a === b) return;
      a.classList.remove('is-active');
      if (!reduce) {
        a.classList.add('is-leaving');
        setTimeout(function () { a.classList.remove('is-leaving'); }, 560);
      }
      b.classList.add('is-active');
      cur = n;
    }
    function loop() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!document.body.contains(bar)) return;
        if (!paused && !document.hidden) show((cur + 1) % msgs.length);
        loop();
      }, secs * 1000);
    }
    if (bar.getAttribute('data-pause') === 'true') {
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
    }
    loop();
  }


  /* ---- scroll animation ---- */
  function initScroll() {
    var cfg = window.LuConfig || {};
    var fx = cfg.scrollFx;
    var root = document.documentElement;
    var design = window.Shopify && window.Shopify.designMode;
    if (cfg.scrollProgress && !design && !document.querySelector('.lu-progress')) {
      var bar = document.createElement('div');
      bar.className = 'lu-progress';
      bar.style.setProperty('--progress-c', cfg.progressColor || '#e5407a');
      document.body.appendChild(bar);
    }
    if (!fx || fx === 'none' || reduce || design) {
      if (cfg.scrollProgress && !design) { bindProgress(); }
      return;
    }
    root.setAttribute('data-scroll-fx', fx);
    root.style.setProperty('--ss', cfg.scrollStrength || 1);
    var secs = [], last = window.pageYOffset, vel = 0, ticking = false;
    function collect() { secs = Array.prototype.slice.call(document.querySelectorAll('section.lu')); }
    collect();
    function frame() {
      ticking = false;
      var y = window.pageYOffset, vh = window.innerHeight || 1;
      vel += ((y - last) / vh * 4 - vel) * .25;
      vel = Math.max(-1, Math.min(1, vel));
      last = y;
      secs.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.bottom < -vh * .5 || r.top > vh * 1.5) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        c = Math.max(-1, Math.min(1, c));
        s.style.setProperty('--sp', c.toFixed(3));
        s.style.setProperty('--sa', Math.abs(c).toFixed(3));
        s.style.setProperty('--sv', vel.toFixed(3));
        if (cfg.scrollReplay) {
          var inView = r.top < vh * .85 && r.bottom > vh * .15;
          Array.prototype.forEach.call(s.querySelectorAll('.lu-reveal'), function (e) {
            if (inView) e.classList.add('is-in'); else if (r.top > vh || r.bottom < 0) e.classList.remove('is-in');
          });
        }
      });
      if (Math.abs(vel) > .01) request();
      progress();
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { collect(); request(); });
    bindProgress(); request();
  }
  function progress() {
    var b = document.querySelector('.lu-progress');
    if (!b) return;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    b.style.setProperty('--sprog', h > 0 ? Math.min(1, Math.max(0, window.pageYOffset / h)).toFixed(4) : 0);
  }
  var pb = false;
  function bindProgress() {
    if (pb) return; pb = true;
    window.addEventListener('scroll', progress, { passive: true });
    progress();
  }


  /* ---- product carousels ---- */
  function initCols(pc, track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.lu-pc__card')), box = document.createElement('div'), anims = [], paused = false, mql = window.matchMedia('(max-width: 749px)');
    box.className = 'lu-pc__cols'; pc.insertBefore(box, track.nextSibling);
    var speed = parseFloat(pc.getAttribute('data-speed')) || 4, canPause = pc.getAttribute('data-pause') !== 'false';
    function build() {
      anims.forEach(function (a) { a.cancel(); }); anims = []; box.innerHTML = '';
      var n = mql.matches ? 2 : (parseInt(getComputedStyle(pc).getPropertyValue('--pc-cols'), 10) || 3); box.style.setProperty('--pc-n', n); pc.classList.add('is-cols');
      for (var c = 0; c < n; c++) {
        var col = document.createElement('div'); col.className = 'lu-pc__col';
        var mine = cards.filter(function (x, i) { return i % n === c; }); if (!mine.length) mine = cards.slice();
        var reps = Math.max(2, Math.ceil(4 / mine.length)); for (var r = 0; r < reps * 2; r++) mine.forEach(function (x) { var k = x.cloneNode(true); if (r >= reps) k.setAttribute('aria-hidden', 'true'); col.appendChild(k); });
        box.appendChild(col);
        if (!reduce && col.animate) { var a = col.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-50%)' }], { duration: 120000 / speed * (1 + c * .22), iterations: Infinity, easing: 'linear', direction: c % 2 ? 'reverse' : 'normal' }); anims.push(a); }
      }
    }
    function setP(on) { if (!canPause) return; anims.forEach(function (a) { on ? a.pause() : a.play(); }); }
    wireNudge(pc, function () { return anims; });
    var rt;
    pc.addEventListener('mouseenter', function () { setP(true); }); pc.addEventListener('mouseleave', function () { setP(false); });
    pc.addEventListener('touchstart', function () { setP(true); clearTimeout(rt); }, { passive: true });
    pc.addEventListener('touchend', function () { clearTimeout(rt); rt = setTimeout(function () { setP(false); }, 2500); }, { passive: true });
    if (mql.addEventListener) mql.addEventListener('change', build); build();
  }


  /* ---- v30: more carousel and grid styles ---- */
  function plain(el) { el.classList.remove('lu-reveal', 'is-in'); el.style.removeProperty('--lu-y'); el.style.removeProperty('--lu-d'); }
  function slice(l) { return Array.prototype.slice.call(l); }
  function wireNudge(pc, src) {
    var prev = pc.querySelector('[data-pc-prev]'), next = pc.querySelector('[data-pc-next]');
    function go(dir) { var list = typeof src === 'function' ? src() : src; list.forEach(function (a) { try { var d = a.effect.getTiming().duration, t = (Number(a.currentTime) || 0) + dir * d * .12; a.currentTime = ((t % d) + d) % d; } catch (e) {} }); }
    if (prev) prev.addEventListener('click', function () { go(-1); }); if (next) next.addEventListener('click', function () { go(1); });
  }
  function initRows(pc, track, two) {
    var cards = slice(track.querySelectorAll('.lu-pc__card')), box = document.createElement('div'), anims = [];
    box.className = 'lu-pc__rows'; pc.insertBefore(box, track.nextSibling); pc.classList.add('is-rows');
    var speed = parseFloat(pc.getAttribute('data-speed')) || 4, canPause = pc.getAttribute('data-pause') !== 'false';
    for (var r = 0; r < (two ? 2 : 1); r++) {
      var row = document.createElement('div'); row.className = 'lu-pc__row';
      var mine = two ? cards.filter(function (x, i) { return i % 2 === r; }) : cards; if (!mine.length) mine = cards.slice();
      var reps = Math.max(2, Math.ceil(9 / mine.length));
      for (var k = 0; k < reps * 2; k++) mine.forEach(function (x) { var c = x.cloneNode(true); if (k >= reps) c.setAttribute('aria-hidden', 'true'); row.appendChild(c); });
      box.appendChild(row);
      if (!reduce && row.animate) anims.push(row.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }], { duration: 150000 / speed * (1 + r * .2), iterations: Infinity, easing: 'linear', direction: r ? 'reverse' : 'normal' }));
    }
    function setP(on) { if (canPause) anims.forEach(function (a) { on ? a.pause() : a.play(); }); }
    wireNudge(pc, anims);
    var rt; pc.addEventListener('mouseenter', function () { setP(true); }); pc.addEventListener('mouseleave', function () { setP(false); });
    pc.addEventListener('touchstart', function () { setP(true); clearTimeout(rt); }, { passive: true });
    pc.addEventListener('touchend', function () { clearTimeout(rt); rt = setTimeout(function () { setP(false); }, 2500); }, { passive: true });
  }
  function initStage(pc, track, mode) {
    var cards = slice(track.querySelectorAll('.lu-pc__card')), n = cards.length, act = 0, timer, speed = parseFloat(pc.getAttribute('data-speed')) || 4, canPause = pc.getAttribute('data-pause') !== 'false';
    if (!n) return; if (mode === 'deck' && n < 3) mode = 'coverflow';
    pc.classList.add('is-stage'); pc.setAttribute('data-mode', mode);
    function size() { var h = 0; cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); }); track.style.height = h + 'px'; }
    function lay() {
      var half = Math.floor(n / 2);
      cards.forEach(function (c, i) {
        var d = mode === 'deck' ? (i - act + n) % n : ((i - act + n + half) % n) - half, a = Math.abs(d), far = mode === 'deck' ? (d > 3 && d < n - 1) : a > 2;
        c.style.setProperty('--d', d); c.style.setProperty('--a', a); c.style.zIndex = mode === 'deck' ? 60 - d : 60 - a;
        far ? c.setAttribute('data-far', '') : c.removeAttribute('data-far');
        mode === 'deck' && d === n - 1 && n > 2 ? c.setAttribute('data-last', '') : c.removeAttribute('data-last');
        d === 0 ? c.setAttribute('data-front', '') : c.removeAttribute('data-front');
      });
    }
    function go(i) { act = (i + n) % n; lay(); }
    function restart() { clearInterval(timer); if (!reduce && n > 1) timer = setInterval(function () { if (!document.hidden) go(act + 1); }, 5200 - speed * 380); }
    cards.forEach(function (c, i) { plain(c); c.addEventListener('click', function (e) { if (i !== act) { e.preventDefault(); e.stopPropagation(); go(i); restart(); } }, true); });
    var prev = pc.querySelector('[data-pc-prev]'), next = pc.querySelector('[data-pc-next]');
    if (prev) prev.addEventListener('click', function () { go(act - 1); restart(); }); if (next) next.addEventListener('click', function () { go(act + 1); restart(); });
    if (canPause) { pc.addEventListener('mouseenter', function () { clearInterval(timer); }); pc.addEventListener('mouseleave', restart); }
    var sx = null; track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) { go(act + (dx < 0 ? 1 : -1)); restart(); } });
    window.addEventListener('resize', size); slice(track.querySelectorAll('img')).forEach(function (im) { if (!im.complete) im.addEventListener('load', size); });
    lay(); size(); setTimeout(size, 400); restart();
  }
  function initGrid(ul) {
    if (ul.__luG) return; ul.__luG = true;
    var mode = ul.getAttribute('data-lu-grid'), items = slice(ul.querySelectorAll('.lu-cg__item')), n = items.length, speed = parseFloat(ul.getAttribute('data-speed')); if (isNaN(speed)) speed = 4;
    if (!n) return; items.forEach(plain);
    if (mode === 'oppcols') {
      var src = items.slice(), mql = window.matchMedia('(max-width: 749px)'), anims = [];
      function build() {
        anims.forEach(function (a) { a.cancel(); }); anims = []; ul.innerHTML = '';
        var cn = mql.matches ? 2 : 3; ul.style.setProperty('--cn', cn);
        for (var c = 0; c < cn; c++) {
          var col = document.createElement('div'); col.className = 'lu-cg__col'; var mine = src.filter(function (x, i) { return i % cn === c; }); if (!mine.length) mine = src.slice();
          var reps = Math.max(2, Math.ceil(5 / mine.length));
          for (var k = 0; k < reps * 2; k++) mine.forEach(function (x) { var cl = x.cloneNode(true); if (k >= reps) cl.setAttribute('aria-hidden', 'true'); col.appendChild(cl); });
          ul.appendChild(col);
          if (!reduce && speed > 0 && col.animate) anims.push(col.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-50%)' }], { duration: 130000 / speed * (1 + c * .2), iterations: Infinity, easing: 'linear', direction: c % 2 ? 'normal' : 'reverse' }));
        }
      }
      ul.addEventListener('mouseenter', function () { anims.forEach(function (a) { a.pause(); }); }); ul.addEventListener('mouseleave', function () { anims.forEach(function (a) { a.play(); }); });
      var rt; ul.addEventListener('touchstart', function () { anims.forEach(function (a) { a.pause(); }); clearTimeout(rt); }, { passive: true });
      ul.addEventListener('touchend', function () { clearTimeout(rt); rt = setTimeout(function () { anims.forEach(function (a) { a.play(); }); }, 2500); }, { passive: true });
      if (mql.addEventListener) mql.addEventListener('change', build); build();
    } else if (mode === 'mosaic') {
      var order = items.slice(), paused = false;
      function shuffle() {
        if (paused || document.hidden || n < 3) return;
        var first = items.map(function (it) { return it.getBoundingClientRect(); });
        order.push(order.shift()); order.forEach(function (it) { ul.appendChild(it); });
        items.forEach(function (it, i) { var r = it.getBoundingClientRect(), f = first[i], dx = f.left - r.left, dy = f.top - r.top, sx = f.width / r.width, sy = f.height / r.height; if (it.animate && !reduce) it.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')' }, { transform: 'none' }], { duration: 900, easing: 'cubic-bezier(.2,.8,.2,1)' }); });
      }
      if (speed > 0 && !reduce) setInterval(shuffle, 7600 - speed * 500);
      ul.addEventListener('mouseenter', function () { paused = true; }); ul.addEventListener('mouseleave', function () { paused = false; });
    } else if (mode === 'strips') {
      var act = 0, timer;
      function on(i) { act = (i + n) % n; items.forEach(function (it, k) { it.classList.toggle('is-on', k === act); }); }
      function rs() { clearInterval(timer); if (speed > 0 && !reduce && n > 1) timer = setInterval(function () { if (!document.hidden) on(act + 1); }, 5200 - speed * 380); }
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { on(i); clearInterval(timer); }); it.addEventListener('mouseleave', rs);
        it.addEventListener('click', function (e) { if (i !== act) { e.preventDefault(); on(i); rs(); } });
      });
      on(0); rs();
    } else if (mode === 'tilt') {
      items.forEach(function (it) {
        var m = it.querySelector('.lu-cg__media'); if (!m) return;
        it.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; var r = it.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height; m.style.setProperty('--ry', ((x - .5) * 18).toFixed(1) + 'deg'); m.style.setProperty('--rx', ((.5 - y) * 14).toFixed(1) + 'deg'); m.style.setProperty('--gx', (x * 100).toFixed(0) + '%'); m.style.setProperty('--gy', (y * 100).toFixed(0) + '%'); it.classList.add('is-hot'); });
        it.addEventListener('pointerleave', function () { m.style.removeProperty('--ry'); m.style.removeProperty('--rx'); it.classList.remove('is-hot'); });
      });
    }
  }

  function initFan(ul) {
    if (ul.__luFan) return; ul.__luFan = true;
    var items = Array.prototype.slice.call(ul.querySelectorAll('.lu-cg__item')), n = items.length, act = 0, timer, speed = parseFloat(ul.getAttribute('data-speed')) || 0;
    if (!n) return; items.forEach(plain);
    function lay() {
      var half = Math.floor(n / 2);
      items.forEach(function (it, i) {
        var d = ((i - act + n + half) % n) - half, a = Math.abs(d);
        it.style.setProperty('--d', d); it.style.setProperty('--a', a); it.style.zIndex = 20 - a;
        if (a > 3) it.setAttribute('data-far', ''); else it.removeAttribute('data-far');
        if (d === 0) it.setAttribute('data-front', ''); else it.removeAttribute('data-front');
      });
    }
    function go(i) { act = (i + n) % n; lay(); }
    function restart() { clearInterval(timer); if (speed > 0 && !reduce && n > 1) timer = setInterval(function () { if (!document.hidden) go(act + 1); }, 4800 - speed * 330); }
    items.forEach(function (it, i) { it.addEventListener('click', function (e) { if (i !== act) { e.preventDefault(); go(i); restart(); } }); });
    ul.addEventListener('mouseenter', function () { clearInterval(timer); }); ul.addEventListener('mouseleave', restart);
    var sx = null; ul.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    ul.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) { go(act + (dx < 0 ? 1 : -1)); restart(); } });
    lay(); restart();
  }

  function initPC(pc) {
    if (pc.__luPc) return; pc.__luPc = true;
    var track = pc.querySelector('.lu-pc__track');
    if (!track) return;
    if (/lu-pc--x[pf]-/.test(pc.className)) { initX(pc); return; }
    if (pc.classList.contains('lu-pc--columns')) { initCols(pc, track); return; }
    if (pc.classList.contains('lu-pc--marquee')) { initRows(pc, track, false); return; }
    if (pc.classList.contains('lu-pc--tworow')) { initRows(pc, track, true); return; }
    if (pc.classList.contains('lu-pc--coverflow')) { initStage(pc, track, 'coverflow'); return; }
    if (pc.classList.contains('lu-pc--focus')) { initStage(pc, track, 'focus'); return; }
    if (pc.classList.contains('lu-pc--deck')) { initStage(pc, track, 'deck'); return; }
    var cards = Array.prototype.slice.call(track.children);
    function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 240; }
    function mark() {
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = null, d = 1e9;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect(), off = r.left + r.width / 2 - mid;
        if (Math.abs(off) < d) { d = Math.abs(off); best = c; }
        c.style.setProperty('--ry', Math.max(-1, Math.min(1, off / (track.clientWidth / 2))) * -10 + 'deg');
      });
      cards.forEach(function (c) { c.classList.toggle('is-center', c === best); });
    }
    var prev = pc.querySelector('[data-pc-prev]'), next = pc.querySelector('[data-pc-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
    if (pc.getAttribute('data-auto') === 'true' && !reduce) {
      var hover = false;
      pc.addEventListener('mouseenter', function () { hover = true; });
      pc.addEventListener('mouseleave', function () { hover = false; });
      setInterval(function () {
        if (hover || document.hidden || !document.body.contains(pc)) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, 3500);
    }
  }

  function initHind(el) {
    if (el.__luH) return; el.__luH = true;
    var tr = el.querySelector('[data-lu-hind-track]'); if (!tr) return;
    function step(d) { var c = tr.querySelector('.lu-hind__card'); var w = c ? c.getBoundingClientRect().width + 10 : tr.clientWidth; var max = tr.scrollWidth - tr.clientWidth; var next = tr.scrollLeft + d * w; if (d > 0 && tr.scrollLeft >= max - 4) next = 0; if (d < 0 && tr.scrollLeft <= 4) next = max; tr.scrollTo({ left: next, behavior: 'smooth' }); }
    var p = el.querySelector('[data-lu-hind-prev]'), n = el.querySelector('[data-lu-hind-next]');
    function pop() { setTimeout(function () { var best = null, bd = 1e9, r0 = tr.getBoundingClientRect().left; Array.prototype.forEach.call(tr.querySelectorAll('.lu-hind__card'), function (c) { var d = Math.abs(c.getBoundingClientRect().left - r0); if (d < bd) { bd = d; best = c; } }); if (best) { best.classList.remove('lu-pop'); void best.offsetWidth; best.classList.add('lu-pop'); } }, 420); }
    if (p) p.addEventListener('click', function () { step(-1); pop(); });
    if (n) n.addEventListener('click', function () { step(1); pop(); });
    autoLoop(el, function () { step(1); pop(); });
  }
  function autoLoop(el, fn) {
    if (el.getAttribute('data-auto') !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ms = (parseFloat(el.getAttribute('data-interval')) || 4) * 1000, hold = false, t;
    el.addEventListener('pointerenter', function () { hold = true; }); el.addEventListener('pointerleave', function () { hold = false; });
    function loop() { clearTimeout(t); t = setTimeout(function () { if (!hold && document.body.contains(el) && !document.hidden) fn(); loop(); }, ms); }
    loop();
  }
  function initCardAuto(card) {
    if (card.__luA) return; card.__luA = true;
    autoLoop(card, function () { var b = card.querySelector('[data-lu-herocard-next]'); if (b) b.click(); });
  }

  function initFree(layer) {
    var items = Array.prototype.slice.call(layer.querySelectorAll('.lu-fl[data-fx="free"]'));
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var host = layer.parentNode, W = 0, H = 0, vis = true, last = 0, running = false;
    function size() { var r = host.getBoundingClientRect(); W = r.width; H = r.height; items.forEach(function (it) { it.__w = it.offsetWidth; it.__h = it.offsetHeight; }); }
    size(); window.addEventListener('resize', size);
    items.forEach(function (it, i) {
      var ang = (i * 137.5) * Math.PI / 180, spd = (parseFloat(getComputedStyle(it).getPropertyValue('--sp')) || 6);
      it.__v = Math.max(30, Math.min(260, (W || 1000) / spd / 1.6));
      it.__vx = Math.cos(ang) * it.__v; it.__vy = Math.sin(ang) * it.__v; it.__ox = 0; it.__oy = 0; it.__stop = false;
      it.addEventListener('pointerenter', function () { it.__hold = true; it.classList.add('is-held'); });
      it.addEventListener('pointerleave', function () { it.__hold = false; it.classList.remove('is-held'); });
      it.addEventListener('touchstart', function () { it.__hold = true; }, { passive: true });
      it.addEventListener('touchend', function () { it.__hold = false; }, { passive: true });
      it.addEventListener('click', function () { it.__stop = true; it.classList.add('is-held'); });
    });
    function tick(t) {
      if (!running) return;
      var dt = Math.min(0.05, (t - last) / 1000 || 0.016); last = t;
      items.forEach(function (it) {
        if (it.__hold || it.__stop || !it.offsetParent) return;
        var cx = it.offsetLeft, cy = it.offsetTop, hw = it.__w / 2 + 6, hh = it.__h / 2 + 6;
        it.__ox += it.__vx * dt; it.__oy += it.__vy * dt;
        var ax = cx + it.__ox, ay = cy + it.__oy;
        if (ax < hw) { it.__ox += hw - ax; it.__vx = Math.abs(it.__vx); }
        if (ax > W - hw) { it.__ox -= ax - (W - hw); it.__vx = -Math.abs(it.__vx); }
        if (ay < hh) { it.__oy += hh - ay; it.__vy = Math.abs(it.__vy); }
        if (ay > H - hh) { it.__oy -= ay - (H - hh); it.__vy = -Math.abs(it.__vy); }
        it.__vx += (Math.random() - .5) * 18 * dt * 10; it.__vy += (Math.random() - .5) * 18 * dt * 10;
        var m = Math.hypot(it.__vx, it.__vy) || 1; it.__vx *= it.__v / m; it.__vy *= it.__v / m;
        it.style.setProperty('--tx', it.__ox.toFixed(1) + 'px'); it.style.setProperty('--ty', it.__oy.toFixed(1) + 'px');
      });
      requestAnimationFrame(tick);
    }
    function start() { if (running) return; running = true; last = performance.now(); requestAnimationFrame(tick); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; if (vis) start(); else running = false; }).observe(host); else start();
  }
  function initFloats(layer) {
    if (layer.__luF) return; layer.__luF = true;
    initFree(layer);
    var mice = Array.prototype.slice.call(layer.querySelectorAll('.lu-fl[data-fx="mouse"]'));
    if (!mice.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var host = layer.parentNode, raf = 0, ex = 0, ey = 0;
    host.addEventListener('pointermove', function (e) {
      var r = host.getBoundingClientRect(); ex = (e.clientX - r.left) / r.width - .5; ey = (e.clientY - r.top) / r.height - .5;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; mice.forEach(function (m, i) { var dpt = 24 + (i % 4) * 14; m.style.setProperty('--tx', (-ex * dpt).toFixed(1) + 'px'); m.style.setProperty('--ty', (-ey * dpt).toFixed(1) + 'px'); }); });
    });
    host.addEventListener('pointerleave', function () { mice.forEach(function (m) { m.style.setProperty('--tx', '0px'); m.style.setProperty('--ty', '0px'); }); });
  }

  /* ---------- v17: mega menu ---------- */
  function initMega() {
    var wrap = document.querySelector('[data-lu-megas]');
    if (!wrap || wrap.__luM) return; wrap.__luM = true;
    var items = document.querySelectorAll('[data-lu-mega]'), cur = null, tm = 0;
    function hide() { if (cur) { cur.hidden = true; cur = null; } Array.prototype.forEach.call(items, function (i) { i.classList.remove('is-open'); }); }
    function show(li) {
      var pn = wrap.querySelector('[data-mega-panel="' + li.getAttribute('data-lu-mega') + '"]');
      if (!pn) return; clearTimeout(tm); hide();
      var r = li.getBoundingClientRect(); pn.style.top = Math.round(r.bottom + 10) + 'px';
      pn.hidden = false; cur = pn; li.classList.add('is-open');
    }
    function later() { clearTimeout(tm); tm = setTimeout(hide, 160); }
    Array.prototype.forEach.call(items, function (li) {
      li.addEventListener('mouseenter', function () { show(li); });
      li.addEventListener('mouseleave', later);
      li.addEventListener('focusin', function () { show(li); });
    });
    wrap.addEventListener('mouseenter', function () { clearTimeout(tm); }, true);
    wrap.addEventListener('mouseleave', later);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    window.addEventListener('scroll', hide, { passive: true });
  }

  /* ---------- v17: search with suggestions ---------- */
  function money(v, cur) { var n = parseFloat(v); if (isNaN(n)) return ''; return cur + ' ' + n.toFixed(2); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function initSearch() {
    var box = document.querySelector('[data-lu-sr]');
    if (!box || box.__luS) return; box.__luS = true;
    var input = box.querySelector('[data-lu-sr-input]'), res = box.querySelector('[data-lu-sr-res]'), base = res.innerHTML;
    var cur = box.getAttribute('data-cur') || '', sUrl = box.getAttribute('data-url') || '/search', tm = 0, seq = 0;
    function open() { box.hidden = false; document.documentElement.classList.add('lu-sr-on'); setTimeout(function () { input.focus(); }, 30); }
    function close() { box.hidden = true; document.documentElement.classList.remove('lu-sr-on'); }
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-lu-search-open]');
      if (o) { e.preventDefault(); open(); return; }
      if (e.target.closest && e.target.closest('[data-lu-sr-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
    function render(q, j) {
      var r = (j && j.resources && j.resources.results) || {}, ps = r.products || [], cs = r.collections || [], h = '';
      if (cs.length) h += '<div class="lu-sr__chips">' + cs.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (ps.length) {
        h += '<ul class="lu-sr__list">' + ps.map(function (p) {
          var im = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var old = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max, cur) + '</s>' : '';
          return '<li><a href="' + esc(p.url) + '">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="lu-sr__noimg"></span>') + '<span class="lu-sr__tt">' + esc(p.title) + '</span><span class="lu-sr__pr"><b>' + money(p.price, cur) + '</b>' + old + '</span></a></li>';
        }).join('') + '</ul>';
        h += '<a class="lu-sr__all" href="' + esc(sUrl) + '?q=' + encodeURIComponent(q) + '">View all results for "' + esc(q) + '" &rarr;</a>';
      } else if (!cs.length) h = '<p class="lu-sr__none">No results for "' + esc(q) + '".</p>';
      res.innerHTML = h;
    }
    input.addEventListener('input', function () {
      clearTimeout(tm); var q = input.value.trim();
      if (q.length < 2) { res.innerHTML = base; return; }
      tm = setTimeout(function () {
        var my = ++seq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); }).then(function (j) { if (my === seq) render(q, j); }).catch(function () { });
      }, 200);
    });
  }

  /* ---------- v17: quick view ---------- */
  function initQV() {
    if (window.__luQV) return; window.__luQV = true;
    var modal = null;
    function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; }
    function fm(c) { return cur() + ' ' + (c / 100).toFixed(2); }
    function close() { if (modal) { modal.remove(); modal = null; document.documentElement.classList.remove('lu-qv-on'); } }
    function strip(h) { var d = document.createElement('div'); d.innerHTML = h || ''; var t = (d.textContent || '').trim(); return t.length > 240 ? t.slice(0, 237) + '...' : t; }
    function open(handle) {
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        close();
        var imgs = (p.images || []).slice(0, 5), sel = {}, v = p.variants[0];
        p.options.forEach(function (o, i) { sel[i] = v['option' + (i + 1)]; });
        modal = document.createElement('div'); modal.className = 'lu-qv'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
        var opts = p.options.length === 1 && p.options[0].name === 'Title' ? '' : p.options.map(function (o, i) {
          return '<div class="lu-qv__opt"><span>' + esc(o.name) + '</span><div>' + o.values.map(function (val) { return '<button type="button" data-oi="' + i + '" data-ov="' + esc(val) + '"' + (sel[i] === val ? ' class="is-on"' : '') + '>' + esc(val) + '</button>'; }).join('') + '</div></div>';
        }).join('');
        modal.innerHTML = '<div class="lu-qv__bg" data-qv-x></div><div class="lu-qv__box"><button type="button" class="lu-qv__x" data-qv-x aria-label="Close">&times;</button>' +
          '<div class="lu-qv__media"><img class="lu-qv__main" src="' + esc(imgs[0] || '') + '" alt="">' + (imgs.length > 1 ? '<div class="lu-qv__th">' + imgs.map(function (u) { return '<img src="' + esc(u) + '" alt="" width="52" height="52">'; }).join('') + '</div>' : '') + '</div>' +
          '<div class="lu-qv__info"><h3>' + esc(p.title) + '</h3><div class="lu-qv__price"></div><p class="lu-qv__d">' + esc(strip(p.description)) + '</p>' + opts +
          '<div class="lu-qv__buy"><div class="lu-qv__qty"><button type="button" data-q="-1">&minus;</button><input type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-q="1">+</button></div><button type="button" class="button lu-qv__add">Add to cart</button></div>' +
          '<p class="lu-qv__msg" role="status"></p><a class="lu-qv__full" href="' + esc(p.url) + '">View full details &rarr;</a></div></div>';
        document.body.appendChild(modal); document.documentElement.classList.add('lu-qv-on');
        var priceEl = modal.querySelector('.lu-qv__price'), addB = modal.querySelector('.lu-qv__add'), msg = modal.querySelector('.lu-qv__msg'), qin = modal.querySelector('.lu-qv__qty input'), main = modal.querySelector('.lu-qv__main');
        function pick() {
          v = p.variants.filter(function (x) { return p.options.every(function (o, i) { return x['option' + (i + 1)] === sel[i]; }); })[0] || null;
          if (!v) { priceEl.innerHTML = ''; addB.disabled = true; addB.textContent = 'Unavailable'; return; }
          priceEl.innerHTML = '<b>' + fm(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + fm(v.compare_at_price) + '</s>' : '');
          addB.disabled = !v.available; addB.textContent = v.available ? 'Add to cart' : 'Sold out';
          if (v.featured_image && v.featured_image.src) main.src = v.featured_image.src;
        }
        pick();
        modal.addEventListener('click', function (e) {
          var t = e.target;
          if (t.closest('[data-qv-x]')) { close(); return; }
          var b = t.closest('[data-oi]'); if (b) { sel[b.getAttribute('data-oi')] = b.getAttribute('data-ov'); Array.prototype.forEach.call(b.parentNode.children, function (c) { c.classList.toggle('is-on', c === b); }); pick(); return; }
          var q = t.closest('[data-q]'); if (q) { qin.value = Math.max(1, (parseInt(qin.value, 10) || 1) + parseInt(q.getAttribute('data-q'), 10)); return; }
          if (t.matches('.lu-qv__th img')) { main.src = t.src; return; }
          if (t === addB && v) {
            addB.disabled = true; msg.textContent = '';
            var cn = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            var secs = cn && cn.tagName === 'CART-DRAWER' ? 'cart-drawer,cart-icon-bubble' : 'cart-notification-product,cart-notification-button,cart-icon-bubble';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: Math.max(1, parseInt(qin.value, 10) || 1) }], sections: secs, sections_url: window.location.pathname }) })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
              .then(function (o) {
                if (!o.ok) { msg.textContent = o.j.description || o.j.message || 'Could not add this item.'; addB.disabled = false; return; }
                close();
                try { var st = (o.j.items && o.j.items[0]) || o.j; st.sections = o.j.sections; if (cn && cn.renderContents) { cn.renderContents(st); } else { window.location.href = '/cart'; } }
                catch (er) { window.location.href = '/cart'; }
              }).catch(function () { msg.textContent = 'Network error. Please try again.'; addB.disabled = false; });
          }
        });
      }).catch(function () { });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lu-qv]');
      if (b) { e.preventDefault(); e.stopPropagation(); open(b.getAttribute('data-lu-qv')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- v17: cart bar (auto code) ---------- */
  function initCartBar() {
    if (window.__luCB) return; window.__luCB = true;
    function run() {
      var b = document.querySelector('[data-lu-cartbar]');
      if (!b || b.getAttribute('data-auto') !== 'true') return;
      var code = b.getAttribute('data-code'); if (!code) return;
      var k = 'lu-code'; try { if (sessionStorage.getItem(k) === code) return; sessionStorage.setItem(k, code); } catch (e) { }
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () { });
    }
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 400); }).observe(document.body, { childList: true, subtree: true });
    run();
  }

  /* ---------- v17: review form ---------- */
  function initReviews() {
    var w = document.querySelector('[data-lu-rev-form]'); if (!w || w.__luR) return; w.__luR = true;
    var btn = document.querySelector('[data-lu-rev-open]');
    if (btn) btn.addEventListener('click', function () { w.toggleAttribute('data-open'); if (w.hasAttribute('data-open')) w.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    if (/contact_posted=true/.test(location.search) || /LuReviewForm/.test(location.hash)) { w.setAttribute('data-open', ''); setTimeout(function () { w.scrollIntoView({ block: 'center' }); }, 300); }
  }

  /* ---- v77: expanding panels (xp) and overlapping fan (xf), looping, for carousel and collection grid ---- */
  function xHost(root, sel) {
    var track = root.classList.contains('lu-cg') ? root : root.querySelector('.lu-pc__track');
    return track ? { track: track, items: slice(track.children).filter(function (c) { return c.matches(sel); }) } : null;
  }
  function initXP(root, track, items, speed, canPause) {
    var n = items.length, act = 0, timer;
    function on(i) { act = (i + n) % n; items.forEach(function (it, k) { it.classList.toggle('is-on', k === act); }); }
    function rs() { clearInterval(timer); if (speed > 0 && !reduce && n > 1) timer = setInterval(function () { if (!document.hidden) on(act + 1); }, 5200 - speed * 380); }
    var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    items.forEach(function (it, i) {
      if (fine) { it.addEventListener('mouseenter', function () { on(i); clearInterval(timer); }); it.addEventListener('mouseleave', rs); }
      it.addEventListener('click', function (e) { if (i !== act) { e.preventDefault(); e.stopPropagation(); on(i); rs(); } }, true);
    });
    var sx = null, sy = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; clearInterval(timer); }, { passive: true });
    track.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null; if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy)) on(act + (dx < 0 ? 1 : -1)); else if (Math.abs(dy) > 36 && Math.abs(dy) > Math.abs(dx) && track.getAttribute('data-vert') === '1') on(act + (dy < 0 ? 1 : -1)); rs(); }, { passive: true });
    var pv = root.querySelector('[data-pc-prev]'), nx = root.querySelector('[data-pc-next]');
    if (pv) pv.addEventListener('click', function () { on(act - 1); rs(); }); if (nx) nx.addEventListener('click', function () { on(act + 1); rs(); });
    on(0); rs();
  }
  function initXF(root, track, items, speed, canPause) {
    var n = items.length, act = 0, timer;
    track.setAttribute('data-n', n);
    function size() { if (root.classList.contains('lu-cg')) return; var h = 0; items.forEach(function (c) { h = Math.max(h, c.offsetHeight); }); track.style.height = (h + 24) + 'px'; }
    function lay() {
      var half = Math.floor(n / 2);
      items.forEach(function (it, i) {
        var d = ((i - act + n + half) % n) - half, a = Math.abs(d);
        if (n % 2 === 0 && d === -half) d = half;
        it.style.setProperty('--d', d); it.style.setProperty('--a', Math.abs(d)); it.style.zIndex = 30 - Math.abs(d);
        Math.abs(d) > 3 ? it.setAttribute('data-far', '') : it.removeAttribute('data-far');
        d === 0 ? it.setAttribute('data-front', '') : it.removeAttribute('data-front');
      });
    }
    function go(i) { act = (i + n) % n; lay(); }
    function rs() { clearInterval(timer); if (speed > 0 && !reduce && n > 1) timer = setInterval(function () { if (!document.hidden) go(act + 1); }, 4800 - speed * 330); }
    items.forEach(function (it, i) { it.addEventListener('click', function (e) { if (i !== act) { e.preventDefault(); e.stopPropagation(); go(i); rs(); } }, true); });
    var prev = root.querySelector('[data-pc-prev]'), next = root.querySelector('[data-pc-next]');
    if (prev) prev.addEventListener('click', function () { go(act - 1); rs(); }); if (next) next.addEventListener('click', function () { go(act + 1); rs(); });
    if (canPause) { root.addEventListener('mouseenter', function () { clearInterval(timer); }); root.addEventListener('mouseleave', rs); }
    var sx = null; track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; clearInterval(timer); }, { passive: true });
    track.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 36) go(act + (dx < 0 ? 1 : -1)); rs(); }, { passive: true });
    window.addEventListener('resize', size); slice(track.querySelectorAll('img')).forEach(function (im) { if (!im.complete) im.addEventListener('load', size); });
    lay(); size(); setTimeout(size, 500); rs();
  }
  function initX(root) {
    if (root.__luX) return; root.__luX = true;
    var m = /--x([pf])-([a-z0-9]+)/.exec(root.className); if (!m) return;
    var sel = root.classList.contains('lu-cg') ? '.lu-cg__item' : '.lu-pc__card', h = xHost(root, sel); if (!h || !h.items.length) return;
    h.items.forEach(function (c) { if (c.classList.contains('lu-cg__item')) plain(c); });
    var speed = parseFloat(root.getAttribute('data-speed')); if (isNaN(speed)) speed = 4;
    var canPause = root.getAttribute('data-pause') !== 'false';
    if (m[2] === 'rows' || m[2] === 'glass') h.track.setAttribute('data-vert', '1');
    m[1] === 'p' ? initXP(root, h.track, h.items, speed, canPause) : initXF(root, h.track, h.items, speed, canPause);
  }
  /* v86: a copy that is hidden on this screen size (desktop/mobile style split) starts when it becomes visible */
  function vis(fn) {
    return function (el) {
      if (!el.closest || !el.closest('.lu-dv') || el.getClientRects().length) return fn(el);
      if (el.__luW || !window.ResizeObserver) return fn(el);
      el.__luW = true;
      var ro = new ResizeObserver(function () { if (el.getClientRects().length) { ro.disconnect(); fn(el); } });
      ro.observe(el);
    };
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-hind]'), initHind);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-herocard]'), initCardAuto);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-floats]'), initFloats);
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-pc]'), vis(initPC));
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-fan]'), vis(initFan));
    Array.prototype.forEach.call(document.querySelectorAll('ul.lu-cg[class*="lu-cg--xp-"],ul.lu-cg[class*="lu-cg--xf-"]'), vis(initX));
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-grid]'), vis(initGrid));
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-ann]'), initBar);
    initMega(); initSearch(); initQV(); initCartBar(); initReviews();
    if (!window.__luScroll) { window.__luScroll = true; initScroll(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
